import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import Select from "react-select";
import { useTranslation } from 'react-i18next';


import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";

// icons
import DescriptionIcon from '@material-ui/icons/Description';
import Check from "@material-ui/icons/Check";
import "beaktShared/components/CustomInput/rotate.css";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";

import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function TermoServicoForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);

    const { register, handleSubmit, setValue, setError, errors, clearError, getValues } = useForm({ mode: "onBlur" });
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);

    const [isLoadingServico, setisLoadingServico] = React.useState(false);
    const [listSelectServicos, setlistSelectServicos] = React.useState([]);
    const [listSelectServicosSelected, setlistSelectServicosSelected] = React.useState([]);
    const [jsonServico, setjsonServico] = React.useState([]);

    const [nomearquivo, setnomearquivo] = React.useState(null)
    const [file, setFile] = React.useState(null);

    const [TermosServicoId, setTermoServicoId] = React.useState(0);

    const LoadSelectServicos = () => {
        setisLoadingServico(true);
        const endPoint = "servicos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                setisLoadingServico(false);
                return false;
            }
            setlistSelectServicos(result.data);
            setisLoadingServico(false);
            return true;
        });
    }

    const handleServicoChange = event => {
        let value = event
        let data = getValues();

        let lstsAdd = [];
        let lstSelect = [];

        value.map(item => {
            lstsAdd.push(item.servicoId);

            lstSelect.push({
                servicoId: item.servicoId,
                termoContratoId: data.id
            });
        });
        setjsonServico(lstsAdd);
        setlistSelectServicosSelected(lstSelect);

        // setjsonServico(value);
        // setValue("servico", value);
        // if (value !== "")
        //     clearError("servico");

    };

    const handleArquivoChange = event => {
        const arquivo = event.target.files[0];
        const fileReader = new FileReader();
        fileReader.onload = function (oFREvent) {
            setFile(oFREvent.target.result);
        }
        fileReader.readAsDataURL(arquivo)
    }

    const intialValues = {
        termoServicoId: 0,
        titulo: '',
        ativo: true,
    };

    useEffect(() => {
        LoadSelectServicos();
    }, []);

    useEffect(() => {
        LoadDadosItem(item);
    }, [item]);

    const LoadDadosItem = (item) => {
        if (!item.termoServicoId)
            return;

        setValue('termoServicoId', (item.termoServicoId === null ? 0 : item.termoServicoId));
        setTermoServicoId((item.termoServicoId === null ? 0 : item.termoServicoId));
        setValue('titulo', item.titulo);
        setValue('ativo', item.ativo);
        setAtivoCheckbox(item.ativo);
        loadSelectTermoView(item.termoServicoRelacaoServicos.length == 0 ? 0 : item.termoServicoRelacaoServicos)

        setnomearquivo(item.nomeArquivo);
    }

    const loadSelectTermoView = (termoServicoList) => {
        if (termoServicoList === null)
            return;

        setlistSelectServicosSelected(termoServicoList);

        setjsonServico(Array.isArray(termoServicoList) ? termoServicoList?.map(item => item.servicoId) : []);
    }

    const onSubmit = (data, e) => {
        e.preventDefault();
        if (jsonServico === null)
            return setError("servico", "required")

        if (file === null && nomearquivo == null)
            return setError("arquivo", "required")

        if (file && nomearquivo != null) {
            if (!file.includes("data:application/pdf;base64,")) {
                setError("arquivo", "", t('information_message.invalid_file_the_extension_must_be_PDF'));
                return;
            }
            else
                clearError(t('label.file'));
        }

        let servicostermo =[];
        if (listSelectServicosSelected.length > 0) {
            listSelectServicosSelected.map(obj => 
                servicostermo.push({
                    servicoId:obj.servicoId,
                    termoServicoId:TermosServicoId === null ? 0 : TermosServicoId
                }));
        }

        let item = {
            termoServicoId: (TermosServicoId === null ? 0 : TermosServicoId),
            servicoId: jsonServico.servicoId,
            titulo: data.titulo,
            ativo: ativoCheckbox,
            ativoDesc: (ativoCheckbox ? t('label.active') : t('label.inactive')),
            arquivo: (file === null ? "" : file.replace("data:application/pdf;base64,", "")),
            nomeArquivo: nomearquivo,
            usuarioCadastroId: session.id,
            TermoServicoRelacaoServicos: servicostermo,
            franquiaId: session.franquiaId
        }


        addItem(item);
    };

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer className={classes.marginTopCard}>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <DescriptionIcon />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('information_message.term_of_service_registration')} - <small>{t('information_message.fill_in_your_details')}</small>
                                    <input className={classes.hidden} defaultValue={intialValues.termoServicoId} name="termoServicoId" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody className={classes.cardMargin}>

                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.titulo ? true : false}
                                                label={t('label.title')}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="titulo"
                                                defaultValue={intialValues.titulo}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 150 }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.titulo && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={errors.servico ? "select__label select__label_error" : "select__label"}>{t('label.service') + " *"}</label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.servico ? true : false)}
                                                isSearchable={true}
                                                isLoading={isLoadingServico}
                                                isMulti={true}
                                                name="servico"
                                                placeholder={t('label.select') + "..."}
                                                options={listSelectServicos}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ servicoId }) => servicoId}
                                                value={listSelectServicos.filter(({ servicoId }) => jsonServico.indexOf(servicoId) != -1)}
                                                onChange={(value) => handleServicoChange(value || [])}
                                                ref={() => register({ name: "servico" })
                                                }
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.servico && <span> {t('label.required')} </span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.arquivo ? true : false}
                                                type="file"
                                                variant="outlined"
                                                onChange={handleArquivoChange}
                                                inputRef={register({ required: (TermosServicoId === null ? t('label.required') : false) })}
                                                name="arquivo"
                                                InputLabelProps={{ shrink: true, required: true }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.arquivo && <span> {errors.arquivo.message}</span>}
                                            </FormHelperText>
                                            <a href={nomearquivo} target="_blank">{nomearquivo === null ? "" : t('label.download_term')}</a>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={ativoCheckbox}
                                                    onClick={event => { setAtivoCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}
                                                    name="ativo"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={t('information_message.system_active')}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>

                        <div className={classes.textCenter}>
                            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}
                                {loading && <div>...{t('label.loading')}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </div>
    );
}
